// src/pages/HeaderPage.js
import React from 'react';
import Header from '../components/Header';

const HeaderPage = () => {
  return (
    <div>
      <Header />
    </div>
  );
};

export default HeaderPage;
